import React, { Suspense } from 'react';
import { Box, Grid, Container } from '@material-ui/core';

import i18n from 'i18n-js';
import Can from 'components/Can';
import Title from 'components/Title';
import Layout from 'components/Layout';
import { useSelector } from 'react-redux';
import Comments from 'components/Comments';
import useStyles from './AlarmDetails.styled';
import * as Components from './RelatedComponent';
import { Details, AlarmLogs } from 'components/Alarms';
import { FormsWidget } from 'components/Forms';
import { withRouter, useParams } from 'react-router-dom';

const AlarmsDetails = () => {
  const classes = useStyles();
  const { id } = useParams();

  const { current } = useSelector((state) => state.alarms || {});

  const instance = () => {
    const { primary_object_type, primary_object_id } = current;
    const Component = Components[primary_object_type] ?? null;
    if (!Component) return;
    return <Component key={1} id={primary_object_id} />;
  };

  return (
    <Layout title={i18n.t('alarm.details')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item>
              <Box style={{ marginBottom: 20 }}>
                <Title title={`${i18n.t('alarm.details')} ID #${id}`} />
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Details id={id} />
                  </Grid>
                  <Grid item xs={12}>
                    <Can I="read" on="event_log">
                      <AlarmLogs id={id} />
                    </Can>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {current?.primary_object_type && (
                      <Suspense fallback={<div>Loading...</div>}>{instance()}</Suspense>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Can I="read" a="comment">
                      <Comments type="alarm" id={parseInt(id)} />
                    </Can>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {current?.primary_object_type === i18n.t('forms.reservation_driver') && (
                      <FormsWidget type="reservation" id={parseInt(current?.primary_object_id)} />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default withRouter(AlarmsDetails);
